import { InjectionToken } from '@angular/core';

export const MW_LAYOUT_OPTIONS = new InjectionToken<LayoutOptions>(
  'MW_LAYOUT_OPTIONS'
);

export interface LayoutOptions {
  clickableTitle?: boolean;
}
